//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'
import Api from '@/utils/api';
import Header from '../Header/Header.vue'
import Swiper from './Swiper.vue'
import Footer from './Footer.vue'
import Content from './Content.vue';
import ShoppCart from './ShoppCart.vue';
import _ from 'lodash';

export default {
    data() {
        return {
            productId: '',
            channel: null,
            product: '',
            res: "",
            item_id: "",
            backName: "home"
        }
    },
    methods: {
        back() {
            if (this.backName == 'orderDetail' || this.backName == "spellGroupDetail" || this.backName == 'spellGroupOrderDetail' || this.backName == 'homeTopNav' || this.backName == "homeSpellGroup") {
                this.$router.go(-1);
                return;
            };
            this.$router.replace({
                name: this.backName
            });
        },
        update(item) {
            this.res = "";
            this.getDetail(item.id);
        },
        getDetail(id) {
            // this.$store.commit('showIsLoading');
            var that = this;
            Api.getProductDetail(this.productId, this.channel)
                .then(res => {
                    this.product = res.data
                    wx.ready(() => {
                        let title = this.product.title
                        if (this.product.specLabel) {
                            title += '(' + this.product.specLabel + ')'
                        }
                        wx.onMenuShareAppMessage({
                            title: title,
                            desc: this.product.subTitle,
                            link: location.href,
                            imgUrl: this.UPLOAD_DOMAIN + this.product.thumbnail,
                            success: function () {
                            }
                        })
                        wx.onMenuShareTimeline({
                            title: title,
                            desc: this.product.subTitle,
                            link: location.href,
                            imgUrl: this.UPLOAD_DOMAIN + this.product.thumbnail,
                            success: function () {
                            }
                        })
                    })
                })
            // getDetail(`item_id=${id}`).then(res => {
            //     if (res.data.error_code != 0) {
            //         if (res.data.error_code == 1) {
            //             this.$store.commit('updateToast', {
            //                 show: true,
            //                 text: '商品不存在'
            //             });
            //             setTimeout(() => {
            //                 this.$router.go(-1);
            //             }, 1000);
            //         };
            //         return;
            //     };
            //     // console.log(JSON.stringify(res));
            //     // console.log(res.data);
            //     this.$store.commit('hideIsLoading');
            //     that.res = res.data;

            //     wxConfigAjax({
            //         title: `【快买酒】` + res.data.item_info.title,
            //         desc: `【快买酒】` + res.data.item_info.sub_title ? res.data.item_info.sub_title : '装在瓶子里的海外阳光',
            //         url: 'Detail/' + res.data.item_info.item_id,
            //         imgUrl: res.data.item_info.image_default_id
            //     });
            // });
        }
    },
    mounted() {
        var id = this.$route.params.id;
        if (this.$route.query.channel) {
            this.channel = this.$route.query.channel
            localStorage.setItem('channel', this.channel);
        }
        this.item_id = id;
        this.productId = id
        this.getDetail(id)

    },
    components: {
        'm-header': Header,
        'm-swiper': Swiper,
        'm-footer': Footer,
        'm-content': Content,
        'm-shoppcart': ShoppCart
    },
    destroyed() {
        this.$store.commit('updateShoppPopup', {
            isTrue: false
        });
    },
    computed: {
        isLogo() {
            return this.$store.state.loginInfo.securitytoken;
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.backName = from.name || 'home';
        });
    },
    watch: {
        isLogo() {
            this.getDetail(this.$route.params.id);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Detail/Detail.vue